{
  "title": "Portfolio Snapshot",
  "clickableSnapshotCard": "Clickable snapshot card",
  "asOfLabel": "As of {{value}}",
  "portfolios_one": "{{count}} portfolio",
  "portfolios_other": "{{count}} portfolios",
  "aumLabel": "{{value}} AUM",
  "refresh": {
    "label": "Refresh"
  },
  "marketStatus": {
    "preMarket": "Pre-Market",
    "open": "Market Open",
    "afterHours": "After Hours",
    "closed": "Market Closed"
  }
}
